import { PlaneIcon } from '../../Landing/ui';

// Dashed flight-route flourish — the article header's signature divider.
export default function RouteFlourish({ className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={`tw-flex tw-items-center tw-justify-center tw-gap-3 ${className}`}
    >
      <span className="tw-h-px tw-w-16 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-top-width:2px]" />
      <PlaneIcon className="tw-h-4 tw-w-4 tw-rotate-90 tw-text-primary-600/60 dark:tw-text-primary-300/50" />
      <span className="tw-h-px tw-w-16 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-top-width:2px]" />
    </div>
  );
}
